// Constants
import { TOP_NAVIGATION_MOBILE } from "constants/navigation/topNavigationMobile";

// Containers
import TopNavigationMobileItemContainer from "containers/molecules/TopNavigationMobileItemContainer";

import "./styles.sass";

const TopNavigationMobile = () => {
  return (
    <div className="TopNavigationMobile">
      {TOP_NAVIGATION_MOBILE.map((item) => (
        <TopNavigationMobileItemContainer item={item} key={item.id} />
      ))}
    </div>
  );
};

export default TopNavigationMobile;
